import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentPage: 1,
    transactionPerPage: 10,
    activeId: 1,
    searchText: "",
    searchType: "all",
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },

        setActiveId: (state, action) => {
            state.activeId = action.payload;
        },

        setSearchText: (state, action) => {
            state.searchType = "all";
            state.searchText = action.payload;
        },

        setSearchType: (state, action) => {
            state.searchText = "";
            state.searchType = action.payload;
        },

        clearFilter: (state) => {
            state.searchText = "";
            state.searchType = "all";
        },
    },
});

export default filterSlice.reducer;
export const {
    setCurrentPage,
    setActiveId,
    setSearchText,
    setSearchType,
    clearFilter,
} = filterSlice.actions;
